export default (uObj, uKey) => {
	let out = null;
	let outNames = [];
	const recursiveObjKey = (userObj, userKey, keys) => {
		userObj.forEach((value) => {
			let newKeys = [...keys];
			if (newKeys.length > 0 && value.id === newKeys[0]) {
				outNames.push({ name: value.name, id: value.id });
				if (newKeys.length > 1) {
					newKeys[1] = newKeys[0] + "_" + newKeys[1];
				}
				newKeys.shift();
			}
			if (value.id === userKey) {
				out = value;
				return;
			} else {
				if (value.projects) {
					recursiveObjKey(value.projects, userKey, newKeys);
				}
			}
		});
	};

	const keys = uKey.split("_");
	recursiveObjKey(uObj, uKey, keys);
	return [out, outNames];
};
